<template>
  <span class="body-1">
    <template v-if="timeIsOver">
      Время истекло
    </template>
    <template v-else-if="timeIsLimited">
      Прошло {{ timeElapsed }} из {{ timeTotal }}
    </template>
    <template v-else> Прошло {{ timeElapsed }} </template>
  </span>
</template>
<script>
import Vue from 'vue'
import dayjs from 'dayjs'

// NODE-STYLE
const relativeTime = require('dayjs/plugin/relativeTime')
require('dayjs/locale/ru')
dayjs.locale('ru')
dayjs.extend(relativeTime)

export default {
  name: 'TestingTimer',
  data() {
    return {
      timer: false,
      lastTime: false,
      slowTimer: false
    }
  },
  props: {
    session: {
      type: Object,
      required: true
    },
    test: {
      type: Object,
      required: true
    }
  },
  computed: {
    startedAt() {
      return new Date(this.session.started)
    },
    timeToLive() {
      return new Date(this.session.sessionTimeToLive)
    },
    millisecondsRemained() {
      if (this.session.sessionTimeToLive && this.lastTime) {
        return this.timeToLive.getTime() - this.lastTime.getTime()
      } else {
        return 0
      }
    },
    millisecondsElapsed() {
      if (this.lastTime && this.startedAt) {
        return (
          this.session.duration * 1000 +
          this.lastTime.getTime() -
          this.startedAt.getTime()
        )
      } else {
        return null
      }
    },
    millisecondsTotal() {
      if (this.test.timeLimit) {
        return this.test.timeLimit * 60 * 1000
      } else {
        return null
      }
    },
    timeElapsed() {
      if (this.millisecondsRemained > 0) {
        const hours = Math.floor(this.millisecondsElapsed / 1000 / 3600)
        const minutes = Math.floor(this.millisecondsElapsed / 1000 / 60) % 60
        const seconds = Math.floor(this.millisecondsElapsed / 1000) % 60
        const parts = []
        if (hours) {
          parts.push(hours)
        }
        parts.push(this.zeroPad(minutes, 2))
        parts.push(this.zeroPad(seconds, 2))
        return parts.join(':')
      } else {
        return '[синхронизация]'
      }
    },
    timeRemained() {
      if (this.millisecondsRemained > 0) {
        const hours = Math.floor(this.millisecondsRemained / 1000 / 3600)
        const minutes = Math.floor(this.millisecondsRemained / 1000 / 60) % 60
        const seconds = Math.floor(this.millisecondsRemained / 1000) % 60
        const parts = []
        if (hours) {
          parts.push(hours)
        }
        parts.push(this.zeroPad(minutes, 2))
        parts.push(this.zeroPad(seconds, 2))
        return parts.join(':')
      } else {
        return 'время истекло'
      }
    },
    timeTotal() {
      const hours = Math.floor(this.millisecondsTotal / 1000 / 3600)
      const minutes = Math.floor(this.millisecondsTotal / 1000 / 60) % 60
      const seconds = Math.floor(this.millisecondsTotal / 1000) % 60
      const parts = []
      if (hours) {
        parts.push(hours)
      }
      parts.push(this.zeroPad(minutes, 2))
      parts.push(this.zeroPad(seconds, 2))
      return parts.join(':')
    },
    timeIsLimited() {
      return Boolean(this.test.timeLimit)
    },
    timeIsOver() {
      return this.millisecondsRemained <= 0
    }
  },
  mounted() {
    this.lastTime = new Date()
    this.timer = setInterval(() => {
      this.timerTick()
    }, 100)
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
    if (this.slowTimer) {
      clearInterval(this.slowTimer)
    }
  },
  methods: {
    zeroPad(v) {
      if (String(v).length < 2) {
        return '0' + v
      } else {
        return v
      }
    },
    timerTick() {
      Vue.set(this, 'lastTime', new Date())
      if (this.millisecondsRemained <= 0) {
        if (!this.slowTimer) {
          clearInterval(this.timer)
          this.timer = false
          this.slowTimer = setInterval(() => {
            this.timerTick()
          }, 2 * 1000)
        }
        this.$emit('timeout')
      }
      if (this.millisecondsRemained <= -30000) {
        clearInterval(this.slowTimer)
        this.slowTimer = false
      }
    }
  }
}
</script>
